import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	accessToken: undefined,
	permissions: undefined,
	user: undefined,
	colors: undefined,
	checkboxs: undefined,
	conditions: undefined,
	locations: undefined,
	sheets: undefined,
	media_url: undefined,
};

const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		userLoggedIn: (state, action) => {
			state.accessToken = action.payload.accessToken;
			state.permissions = action.payload.permissions;
			state.user = action.payload.user;
			state.colors = action.payload.colors;
			state.checkboxs = action.payload.checkboxs;
			state.conditions = action.payload.conditions;
			state.locations = action.payload.locations;
			state.sheets = action.payload.sheets;
			state.media_url = action.payload.media_url;
			state.shipping_agreement = action.payload.shipping_agreement;
		},
		userLoggedOut: (state) => {
			state.accessToken = undefined;
			state.permissions = undefined;
			state.user = undefined;
			state.colors = undefined;
			state.checkboxs = undefined;
			state.conditions = undefined;
			state.locations = undefined;
			state.sheets = undefined;
			state.media_url = undefined;
		},
	},
});

export const { userLoggedIn, userLoggedOut } = authSlice.actions;
export default authSlice.reducer;
